import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Modal from "@mui/material/Modal";
import db from "../db";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";


const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "80%",
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4,
};

const columns = [
	{ id: "name", label: "Business Name", minWidth: 170 },
	{ id: "booth", label: "Selected Booth", minWidth: 100 },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: "#a67a31",
		color: theme.palette.common.white,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(() => ({
	"&:nth-of-type(odd)": {
		backgroundColor: "rgba(166, 122, 49, 0.1)",
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));

export default function BookingModal(props) {
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const [reservations, setReservations] = useState([]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const getReservations = () => {
    db.collection("Reservation").onSnapshot(querySnap => {
      let reservation = []
      querySnap.forEach(doc => {
        console.log("doc ", doc.data())
        reservation.push({id: doc.id, ...doc.data() })
      })
      setReservations(reservation);
    })

	};

	useEffect(() => {
		getReservations();
	}, []);

	return (
		<Modal
			open={props.openModal}
			onClose={() => props.closeModal(false)}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Paper sx={style}>
				<TableContainer sx={{ maxHeight: 440 }}>
					<Table stickyHeader aria-label="sticky table">
						<TableHead>
							<StyledTableRow>
								{columns.map((column) => (
									<StyledTableCell
										key={column.id}
										align={column.align}
										style={{ minWidth: column.minWidth }}
									>
										{column.label}
									</StyledTableCell>
								))}
							</StyledTableRow>
						</TableHead>
						<TableBody>
							{reservations &&
								reservations
									.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
									.map((row, index) => {
										return (
											<StyledTableRow role="checkbox" tabIndex={-1} key={index}>
												<StyledTableCell>
													{row.exhibitor.businessName}
												</StyledTableCell>
												<StyledTableCell>{row.booth.name}</StyledTableCell>
											</StyledTableRow>
										);
									})}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 50, 100]}
					component="div"
					count={reservations && reservations.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Paper>
		</Modal>
	);
}
